var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('HeroSection'),_c('CategoriesList'),_c('section',{staticClass:"py-5"},[_vm._m(0),_c('ProductsList')],1),_c('Services'),_c('NewsLetter')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',[_c('p',{staticClass:"small text-muted small text-uppercase mb-1"},[_vm._v(" Made the hard way ")]),_c('h2',{staticClass:"h5 text-uppercase mb-4"},[_vm._v("Top trending products")])])
}]

export { render, staticRenderFns }